import React from "react";
import PropTypes from "prop-types";
import { Header } from "../../../Header";
import { ModalFooter } from "../ModalFooter";
import { ModalContent } from "../ModalContent";
import { SectionLeft } from "../SectionLeft";
import { ContentDescription } from "../ContentDescription";
import { SectionRight } from "../SectionRight";
import { PCRTubeHintsBlock } from "../PCRTubeHintsBlock";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { TUBE_TYPES } from "../Microcentrifuge.utils";
import { BalanceTubesPanel } from "../BalanceTubesPanel";
import "./style.scss";

export function BalanceTubeModal(props) {
  const hasPCRTube = React.useMemo(() => {
    return props.slots.some((slot) => slot.tubeType === TUBE_TYPES.PCR);
  }, [props.slots]);

  return (
    <Modal className="balanceModal" isOpen={props.isOpen} size={props.size}>
      <Header
        label="THE MICROCENTRIFUGE (TOP VIEW)"
        close={props.onClose}
        size="md"
      />
      <ModalContent className="balanceModal_content">
        <SectionLeft className="balanceModal_content_left">
          <ContentDescription
            className="balanceModal_content_left_contentDescription"
            title="Balance the microcentrifuge"
            description="Distribute the tubes evenly to balance the centrifuge."
          />
          <PCRTubeHintsBlock
            className="balanceModal_content_left_pcrhint"
            hasPCRTube={hasPCRTube}
          />
        </SectionLeft>
        <SectionRight className="balanceModal_content_right">
          <BalanceTubesPanel
            balanced={props.balanced}
            className="balanceModal_content_right_panel"
            onTubeDrop={props.onTubeDrop}
            slots={props.slots}
          />
        </SectionRight>
      </ModalContent>
      <ModalFooter
        text="Done"
        className="balanceModal_footer"
        onClick={props.onClose}
        disabled={!props.balanced}
      />
    </Modal>
  );
}

BalanceTubeModal.propTypes = {
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * List of tubes in apparatus with its status.
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
  /**
   * Function to invoke when solution tube is dropped
   */
  onTubeDrop: PropTypes.func,
};

BalanceTubeModal.defaultProps = {
  showClose: true,
  size: "md",
};
